import React from 'react';

import { useCurrentAircraft } from 'ff/debrief/hooks';
import { useFormikContext } from 'formik';

import { VspeedFormValues } from 'ff/debrief/components/modals/VspeedModal/VspeedFormValues';
import { useVspeedModalLogic } from 'ff/debrief/components/modals/VspeedModal/useVspeedModalLogic';
import AircraftForm from 'ff/debrief/components/modals/VspeedModal/AircraftForm';
import VspeedsTableSection from 'ff/debrief/components/modals/VspeedModal/VspeedsTableSection';
import VspeedModalActions from 'ff/debrief/components/modals/VspeedModal/VspeedModalActions';
import { isCustom } from 'ff/debrief/utils';

const VspeedOverrideForm = () => {
    const { values } = useFormikContext<VspeedFormValues>();
    const { standardSpeeds } = useCurrentAircraft();
    const {
        close,
        modelList,
        aircraftProfile,
        handleTailChange,
        handleAircraftModelChange,
    } = useVspeedModalLogic();

    const isCustomModel =
        !values.aircraftModel?.model || isCustom(values.aircraftModel.model);

    return (
        <>
            <AircraftForm
                modelList={modelList}
                onTailChange={handleTailChange}
                onAircraftModelChange={handleAircraftModelChange}
            />
            <VspeedsTableSection
                standardSpeeds={standardSpeeds}
                aircraftProfile={aircraftProfile}
                isCustom={isCustomModel}
                disabled={!values.aircraftModel}
            />
            <VspeedModalActions onClose={close} />
        </>
    );
};

export default VspeedOverrideForm;
